import Axios from 'axios';

export const baseURL = 'https://0pem8y59pk.execute-api.eu-west-1.amazonaws.com';

const axios = Axios.create({
  baseURL: `${baseURL}/prod/`,
});

export default axios;